// extracted by mini-css-extract-plugin
export default {"gallery":"v_pts","galleryItem":"SBUVr","productItem":"PdzZx","wrapper":"pc_wS","productItemUzb":"dmb0n"};